// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"478":"a632559b","482":"580a4899","498":"1bc8ab23","589":"a632559b","592":"a963225b","738":"a632559b"}[chunkId] + ".chunk.css";
};